import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { DirectMessageTemplate, HtmlMappingTemplate } from '@quorum/models/xs-resource';
import { filter } from 'rxjs/operators';
import { selectAll as selectActionTypesCombined } from './action-types/action-types.interfaces';
import { selectAll as selectAssociateClassesCombined } from './associate-classes/associate-classes.interfaces';
import { selectAll as selectCustomerTypesCombined } from './customer-types/customer-types.interfaces';
import { selectAll as selectDeclinedReasonsCombined } from './declined-reasons/declined-reasons.interfaces';
import * as fromDirectMessageTemplates from './direct-message-templates/direct-message-templates.actions';
// eslint-disable-next-line max-len
import { selectAll as selectDirectMessageTemplatesCombined } from './direct-message-templates/direct-message-templates.interfaces';
import { selectAll as selectEmployeesCombined } from './employees/employees.interfaces';
import * as fromHtmlMappingTemplates from './html-mapping-templates/html-mapping-templates.actions';
// eslint-disable-next-line max-len
import { selectAll as selectHtmlMappingTemplatesCombined } from './html-mapping-templates/html-mapping-templates.interfaces';
import { selectAll as selectMailMergesCombined } from './mail-merges/mail-merges.interfaces';
import { selectAll as selectMessageTypesCombined } from './message-types/message-types.interfaces';
import { selectAll as selectRooftopsCombined } from './rooftops/rooftops.interfaces';
// eslint-disable-next-line max-len
import { selectAll as selectServiceGroupCategoriesCombined } from './service-group-categories/service-group-categories.interfaces';
// eslint-disable-next-line max-len
import { selectAll as selectServiceGroupSubCategoriesCombined } from './service-group-sub-categories/service-group-sub-categories.interfaces';
import { selectAll as selectTaskOutcomesCombined } from './task-outcomes/task-outcomes.interfaces';
import { selectAll as selectVehicleCategoriesCombined } from './vehicle-categories/vehicle-categories.interfaces';
import { selectAll as selectVehicleColoursCombined } from './vehicle-colours/vehicle-colours.interfaces';
// eslint-disable-next-line max-len
import { selectAll as selectVehicleGenericModelsCombined } from './vehicle-generic-models/vehicle-generic-models.interfaces';
import { selectAll as selectVehicleMakesCombined } from './vehicle-makes/vehicle-makes.interfaces';
import { selectAll as selectVehicleStatusesCombined } from './vehicle-statuses/vehicle-statuses.interfaces';
// eslint-disable-next-line max-len
import { selectAll as selectVehicleSubcategoriesCombined } from './vehicle-subcategories/vehicle-subcategories.interfaces';
import { selectAll as selectVehicleSubTypesCombined } from './vehicle-subtypes/vehicle-subtypes.interfaces';

@Injectable()
export class DropdownsStateService {
  constructor(private store: Store<any>) {}

  selectEmployees() {
    return this.store.pipe(select(selectEmployeesCombined));
  }

  selectMailMerges() {
    return this.store.pipe(select(selectMailMergesCombined));
  }

  selectCustomerTypes() {
    return this.store.pipe(select(selectCustomerTypesCombined));
  }

  selectMessageTypes() {
    return this.store.pipe(select(selectMessageTypesCombined));
  }

  selectRooftops() {
    return this.store.pipe(select(selectRooftopsCombined));
  }

  selectVehicleCategories() {
    return this.store.pipe(select(selectVehicleCategoriesCombined));
  }

  selectVehicleColours() {
    return this.store.pipe(select(selectVehicleColoursCombined));
  }
  selectVehicleGenericModels() {
    return this.store.pipe(select(selectVehicleGenericModelsCombined));
  }

  selectVehicleMakes() {
    return this.store.pipe(select(selectVehicleMakesCombined));
  }

  selectVehicleStatuses() {
    return this.store.pipe(select(selectVehicleStatusesCombined));
  }

  selectVehicleSubcategories() {
    return this.store.pipe(select(selectVehicleSubcategoriesCombined));
  }

  selectVehicleSubTypes() {
    return this.store.pipe(select(selectVehicleSubTypesCombined));
  }

  selectTaskOutcomes() {
    return this.store.pipe(select(selectTaskOutcomesCombined));
  }

  selectTextMessageTemplates() {
    this.getTextMessageTemplatesFromServer();
    return this.store.pipe(
      select(selectDirectMessageTemplatesCombined),
      filter((directMessageTemplates: DirectMessageTemplate[]) => {
        return !this.isEmpty(directMessageTemplates);
      })
    );
  }

  getTextMessageTemplatesFromServer() {
    return this.store.dispatch(new fromDirectMessageTemplates.GetDirectMessageTemplatesFromServer({}));
  }

  selectHtmlMappingTemplates() {
    this.getHtmlMappingTemplatesFromServer();
    return this.store.pipe(
      select(selectHtmlMappingTemplatesCombined),
      filter((htmlMappingTemplates: HtmlMappingTemplate[]) => {
        return !this.isEmpty(htmlMappingTemplates);
      })
    );
  }

  getHtmlMappingTemplatesFromServer() {
    return this.store.dispatch(new fromHtmlMappingTemplates.GetHtmlMappingTemplatesFromServer({}));
  }

  selectAssociateClasses() {
    return this.store.pipe(select(selectAssociateClassesCombined));
  }

  selectServiceGroupCategories() {
    return this.store.pipe(select(selectServiceGroupCategoriesCombined));
  }

  selectServiceGroupSubCategories() {
    return this.store.pipe(select(selectServiceGroupSubCategoriesCombined));
  }

  selectDeclinedReasons() {
    return this.store.pipe(select(selectDeclinedReasonsCombined));
  }

  selectActionTypes() {
    return this.store.pipe(select(selectActionTypesCombined));
  }

  isEmpty(obj: any) {
    for (var key in obj) {
      if (obj.hasOwnProperty(key)) return false;
    }
    return true;
  }
}
